module.exports = __webpack_public_path__ + "img/20191012162011u=2921364010,3547817580&fm=214&gp=0.ca05ba50.jpg";